var $=jQuery;
jQuery(document).ready(function ($) {
  
  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  var counted = false;
  if ($('.counter').length > 0) {
  $(window).on('scroll', function () {
    var $counter = $('.counter');
    if (isScrolledIntoView($counter) && !counted) {
      counted = true;

      $('.counter').each(function () {
        var show = '';
        var $this = $(this),
            countTo = $this.attr('data-count');
            show = $(this).attr('data-show');
    
        $({ countNum: $this.text() }).animate({
          countNum: countTo,
        },
        {
          duration: 2000,
          easing: 'swing',
          step: function () {
            $this.text(Math.floor(this.countNum));
          },
          complete: function () {
            $this.text(show);
          }
        });
      });
    }
  });
  }
  //slider mini cart
  var swiper = new Swiper('.slider-upsell', {
    slidesPerView: 1,
    spaceBetween:0,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 50000,
      disableOnInteraction: false,
    }
  });
 
  $('.footer .has-dropdown.footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
});

$(document).ready(function(){
  if ($(window).width() < 950) {
      $(".product__media-list-custom").flickity({
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: true,
          pageDots: false,
          autoPlay: true,
      });  
  };
  ///// Tab Faq
  $(document).on('click','.acctab_title', function(e){
     if($(window).width() >= 768){
        $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }else{
       $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }
  });
  $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
      $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
  });
  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
  });
  ///// Tab Faq
});

/****** theme custom menu appears on hover End ******/
// document.addEventListener('DOMContentLoaded', function() {
//     document.querySelectorAll('.has_slider').forEach(function(slider) {
//         new Swiper(slider, { 
//             loop: true,
//             pagination: {
//                 el: slider.querySelector(".swiper-pagination"),
//                 clickable: true,
//             },
//             navigation: {
//                 nextEl: slider.querySelector('.swiper-button-next'),
//                 prevEl: slider.querySelector('.swiper-button-prev'),
//             },
//             autoplay: {
//                 delay: 5000, 
//                 disableOnInteraction: false, 
//             },
//             breakpoints: {
//                 300: {
//                     slidesPerView: 1, 
//                     spaceBetween: 10
//                 },
//                 991: {
//                     slidesPerView: 2, 
//                     spaceBetween: 15
//                 }
//             }
//         });
//     });
// });


//price custom
class PriceRange1 extends HTMLElement {
    connectedCallback() {
      this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
      this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
      this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
      this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");
  
      // Event listeners for text input focus and change
      this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
      this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());
  
      this.textInputLowerBound.addEventListener("change", (event) => {
        const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
        event.target.value = newValue;
        this.rangeLowerBound.value = newValue;
        this.updateRangeStyles();
      });
  
      this.textInputHigherBound.addEventListener("change", (event) => {
        const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
        event.target.value = newValue;
        this.rangeHigherBound.value = newValue;
        this.updateRangeStyles();
      });
  
      // Event listeners for range slider change and input
      this.rangeLowerBound.addEventListener("change", (event) => {
        this.textInputLowerBound.value = event.target.value;
        this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeHigherBound.addEventListener("change", (event) => {
        this.textInputHigherBound.value = event.target.value;
        this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeLowerBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
        this.textInputLowerBound.value = event.target.value;
        this.updateRangeStyles();
      });
  
      this.rangeHigherBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
        this.textInputHigherBound.value = event.target.value;
        this.updateRangeStyles();
      });
    }
  
    updateRangeStyles() {
      this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
      this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
    }
}
window.customElements.define("price-range1", PriceRange1);


// Open popup when any .open-popup element is clicked
document.querySelectorAll('.quick-add a.button.button--primary').forEach(button => {
  button.addEventListener('click', function(e) {
    e.preventDefault(); // Prevent default action (e.g., for links)
    document.getElementById('popup').style.display = 'flex';
  });
});

// Close popup when .close is clicked
document.querySelector('.close').addEventListener('click', function() {
  document.getElementById('popup').style.display = 'none';
});